var map = {
	"./clean-code.svg": "936d",
	"./devices.svg": "a383",
	"./domain-registration.svg": "4a51",
	"./framework.svg": "a943",
	"./new-file.svg": "28b5",
	"./skills.svg": "9c42",
	"./speedometer.svg": "0fde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f350";